export const ANGLE_TAG_EXCLUSIONS = {
  PANO: "pano",
  HD: "hd",
} as const;
